import React, { useState } from "react";
import api from "../api/api";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import loginImg from "../assets/img/login.jpeg";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Login → backend sets cookies
      await api.post("/auth/login", {
      email,
      password,
      rememberMe
    });

    const me = await api.get("/auth/me");

    // redirect
    if (me.data.role === "admin") {
      navigate("/admin/contents");
    } else {
      navigate("/swip");
    }
    window.location.reload();

    } catch (err) {
      alert(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet><title>LCWE | Login</title></Helmet>

      <section className="p-3 p-md-4 p-xl-5">
        <div className="container">
          <div className="card border-light-subtle shadow-sm">
            <div className="row g-0">
              <div className="col-12 col-md-6">
                <img src={loginImg} className="img-fluid rounded-start w-100 h-100 object-fit-cover" loading="lazy" alt="Login" />
              </div>
              <div className="col-12 col-md-6">
                <div className="card-body p-3 p-md-4 p-xl-5">
                  <div className="mb-5"> <h3>Sign In</h3> </div>
                <form onSubmit={handleSubmit}>
                  <div className="row gy-3 gy-md-4 overflow-hidden">
                    <div className="col-12">
                      <label htmlFor="email" className="form-label"> Email <span className="text-danger">*</span> </label>
                      <input type="email" className="form-control mb-3"
                      placeholder="Email" value={email} id="email"
                      onChange={e => setEmail(e.target.value)} required />
                    </div>

                    <div className="col-12">
                      <label htmlFor="password" className="form-label"> Password <span className="text-danger">*</span> </label>
                      <input type="password" className="form-control mb-3"
                      placeholder="Password" value={password} id="password"
                      onChange={e => setPassword(e.target.value)} required />
                    </div>

                    <div className="col-12 form-check mb-3">
                      <input type="checkbox" className="form-check-input"
                        checked={rememberMe}
                        onChange={e => setRememberMe(e.target.checked)} />
                      <label className="form-check-label">Remember me</label>
                    </div>

                    <div className="col-12">
                      <div className="d-grid">
                        <button className="btn btn-primary w-100" disabled={loading}>
                          {loading ? "Signing in..." : "Sign In"}
                        </button>
                      </div>
                    </div>

                    <div className="col-12 text-center mt-3"> Don't have an account?{" "} <a href="/signup">Sign up here</a> </div>

                  </div>
                </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Login;
